import { transform } from '@utils/intl_lang'
export enum NO_PERMISSION_TYPE {
  NO_CORPORATE_IDENTITY = '1',
  NO_HOMEPAGE = '2',
}

export const NO_PERMISSION = {
  [NO_PERMISSION_TYPE.NO_CORPORATE_IDENTITY]: {
    // '抱歉，你没有企业身份，无法使用e祺学网页版'
    TIP: transform('no_corporate_identity'),
    LOGOUT: false,
  },
  [NO_PERMISSION_TYPE.NO_HOMEPAGE]: {
    // '抱歉，你没有可见的首页，无法使用e祺学网页版'
    TIP: transform('no_homepage'),
    LOGOUT: false,
  },
}
